<template>
  <div class="result__wrapper">
    <div v-if="text">
      <p class="team-result__text" v-html="text" />
    </div>
  </div>
</template>
<script>
import Util from '@/util'
import { mapState } from 'vuex'

export default {
  props: {
    resultTeam: {
      type: Object,
      default: () => {},
    },
    resultSolo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      typeAnswer: '',
      result: {},
      text: '',
      isFastestAudience: false,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      isCorrectGetPoint: (state) => state.slide.isCorrectGetPoint,
      otherCorrectQuiz: (state) => state.slide.otherCorrectQuiz,
      slideOptions: (state) => state.slide.SlideOptions,
      slideType: (state) => state.slideType,
      teamScoringRule: (state) => state.presentation.teamScoringRule,
      teamPlay: (state) => state.presentation.teamPlay,
    }),
  },
  mounted() {
    this.result = this.resultSolo
    if (!this.resultTeam.noData) {
      this.result.fastest = this.resultTeam[this.$store.state.audienceQuizTeam]
      this.isFastestAudience =
        this.result.fastest && this.result.fastest.audience === this.audienceId
    }
    this.getCorrectTypeAnswerText()
    this.text = this.getResultText()
  },
  methods: {
    getCorrectTypeAnswerText() {
      if (this.slideType === 'typeAnswer') {
        if (this.$store.state.slide.correctQuizTypeAnswer) {
          this.typeAnswer = this.$store.state.slide.correctQuizTypeAnswer
        } else if (
          this.otherCorrectQuiz &&
        this.otherCorrectQuiz.length
        ) {
          this.otherCorrectQuiz.forEach((item) => {
            if (item.title && !this.typeAnswer) {
              this.typeAnswer = item.title
            }
          })
        }
      }
    },
    getResultText() {
      // https://docs.google.com/spreadsheets/d/1zag4Rutp910q2QnTyxGhS_q4RpoGZTcBKiHcCzQU7-E/edit#gid=0
      const dataCorrectAnswers =
        Util.getDataCorrectAnswers(this.$store.state.slide.SlideOptions, this.result)
      const partiallyCorrect =
        dataCorrectAnswers.totalCorrectAnswers > 1 &&
        dataCorrectAnswers.audienceCorrectAnswers.length > 0 &&
        dataCorrectAnswers.audienceCorrectAnswers.length !== dataCorrectAnswers.totalCorrectAnswers
      const text = ''
      const { teamScoringRule } = this.$store.state.presentation
      const { slide } = this.$store.state

      if (teamScoringRule === 'fastest') {
        // no data H8 H9 10
        if (this.resultTeam.noData) {
          return `${this.getTextNoOneTeamAnswerInTime()}<br>${this.getYourTeamHasScoredPoints(0)}`
        }
        // H5
        if (this.result.timeout && !this.isFastestAudience &&
          slide.multipleChoice && !this.isCorrectGetPoint) {
          return `${this.getTextRunOutOfTime()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // H6
        if (this.result.timeout && !this.isFastestAudience &&
          slide.multipleChoice && this.isCorrectGetPoint) {
          return `${this.getTextRunOutOfTime()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // H7
        if (this.result.timeout && !this.isFastestAudience &&
          !slide.multipleChoice) {
          return `${this.getTextRunOutOfTime()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // Partially correct
        // I5
        if (!this.result.timeout && !this.isFastestAudience &&
          slide.multipleChoice && !this.isCorrectGetPoint && partiallyCorrect) {
          return `${this.getTextYourAnswerNotCount()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // I6
        if (!this.result.timeout && !this.isFastestAudience &&
          slide.multipleChoice && this.isCorrectGetPoint && partiallyCorrect) {
          return `${this.getTextYourAnswerNotCount()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // I8
        if (!this.result.timeout && this.isFastestAudience &&
          slide.multipleChoice && !this.isCorrectGetPoint && partiallyCorrect) {
          return `${this.getTextYouMissedCorrectAnswers(dataCorrectAnswers)}<br>${this.getTextFastestYouHaveWonPointsForTeam()}.`
        }
        // I9
        if (!this.result.timeout && this.isFastestAudience &&
          slide.multipleChoice && this.isCorrectGetPoint && partiallyCorrect) {
          return `${this.getTextYouPickedCorrectAnswers(dataCorrectAnswers)}<br>${this.getTextFastestYouHaveWonPointsForTeam()}.`
        }
        // End of partially correct
        // F5
        if (!this.result.timeout && !this.isFastestAudience &&
          slide.multipleChoice && !this.isCorrectGetPoint && this.result.correct) {
          return `${this.getTextYourAnswerNotCount()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // F6
        if (!this.result.timeout && !this.isFastestAudience &&
          slide.multipleChoice && this.isCorrectGetPoint && this.result.correct) {
          return `${this.getTextYourAnswerNotCount()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // F7
        if (!this.result.timeout && !this.isFastestAudience &&
          !slide.multipleChoice && this.result.correct) {
          return `${this.getTextYourAnswerNotCount()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // G5
        if (!this.result.timeout && !this.isFastestAudience &&
          slide.multipleChoice && !this.isCorrectGetPoint && !this.result.correct) {
          return `${this.getTextYourAnswerNotCount()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // G6
        if (!this.result.timeout && !this.isFastestAudience &&
          slide.multipleChoice && this.isCorrectGetPoint && !this.result.correct) {
          return `${this.getTextYourAnswerNotCount()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // G7
        if (!this.result.timeout && !this.isFastestAudience &&
          !slide.multipleChoice && !this.result.correct) {
          return `${this.getTextYourAnswerNotCount()}<br>${this.getTextFastestTeamMateAlreadyAnswer()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // H8
        if (this.result.timeout && this.isFastestAudience &&
          slide.multipleChoice && !this.isCorrectGetPoint) {
          return `${this.getTextNoOneTeamAnswerInTime()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // H9
        if (this.result.timeout && this.isFastestAudience &&
          slide.multipleChoice && this.isCorrectGetPoint) {
          return `${this.getTextNoOneTeamAnswerInTime()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // H10
        if (this.result.timeout && this.isFastestAudience &&
          !slide.multipleChoice) {
          return `${this.getTextNoOneTeamAnswerInTime()}<br>${this.getFastestYourTeamHasScoredPoints()}`
        }
        // F8
        if (!this.result.timeout && this.isFastestAudience &&
          slide.multipleChoice && !this.isCorrectGetPoint && this.result.correct) {
          return `${this.getTextYouWereTheFastest()}<br>${this.getTextFastestYouHaveWonPointsForTeam()}!`
        }
        // F9
        if (!this.result.timeout && this.isFastestAudience &&
          slide.multipleChoice && this.isCorrectGetPoint && this.result.correct) {
          return `${this.getTextYouWereTheFastest()}<br>${this.getTextFastestYouHaveWonPointsForTeam()}!`
        }
        // F10
        if (!this.result.timeout && this.isFastestAudience &&
          !slide.multipleChoice && this.result.correct) {
          return `${this.getTextYouWereTheFastest()}<br>${this.getTextFastestYouHaveWonPointsForTeam()}!`
        }
        // G8
        if (!this.result.timeout && this.isFastestAudience &&
          slide.multipleChoice && !this.isCorrectGetPoint && !this.result.correct) {
          return `${this.getTextYouWereTheFastest()}<br>${this.getTextFastestYouHaveWonPointsForTeam()}.`
        }
        // G9
        if (!this.result.timeout && this.isFastestAudience &&
          slide.multipleChoice && this.isCorrectGetPoint && !this.result.correct) {
          return `${this.getTextYouWereTheFastest()}<br>${this.getTextFastestYouHaveWonPointsForTeam()}.`
        }
        // G10
        if (!this.result.timeout && this.isFastestAudience &&
          !slide.multipleChoice && !this.result.correct) {
          return `${this.getTextYouWereTheFastest()}<br>${this.getTextFastestYouHaveWonPointsForTeam()}.`
        }
      }
      // isCorrectGetPoint: The more the better
      if (teamScoringRule === 'average') {
        // H11, H12, H13
        if (this.result.timeout) {
          return this.$t('runOutOfTime')
        }

        // I11
        if (slide.multipleChoice && partiallyCorrect && !this.isCorrectGetPoint) {
          return `${this.getTextYouMissedCorrectAnswers(dataCorrectAnswers)}<br>${this.$t('youScoredPointsForYourTeam', { msg: 0 })}`
        }

        // I12
        if (slide.multipleChoice && partiallyCorrect && this.isCorrectGetPoint) {
          return `${this.getTextYouPickedCorrectAnswers(dataCorrectAnswers)}<br>${this.$t('youScoredPointsForYourTeam', { msg: Util.formatNumber(this.result.point) })}`
        }

        // F11, F12, F13
        if (this.result.correct) {
          return this.$t('youScoredPoints', {
            msg: `<strong>${Util.formatNumber(this.result.point)}</strong>` || 0,
          })
        }

        // G11, G12, G13
        if (!this.result.correct) {
          return this.$t('youScoredPointsForYourTeam', {
            msg: 0,
          })
        }
      }

      if (teamScoringRule === 'total') {
        if (this.resultTeam.noData) {
          return `${this.getTextRunOutOfTime()}<br>${this.$t('yourTeamWonPointTotal', {
            msg: '<strong>0</strong>',
          })}`
        }
        // H14
        if (this.result.timeout && slide.multipleChoice && !this.isCorrectGetPoint) {
          return `${this.getTextRunOutOfTime()}<br>${this.getYourTeamWonPointsTotal()}.`
        }
        // H15
        if (this.result.timeout && slide.multipleChoice && this.isCorrectGetPoint) {
          return `${this.getTextRunOutOfTime()}<br>${this.getYourTeamWonPointsTotal()}.`
        }
        // H15
        if (this.result.timeout && !slide.multipleChoice) {
          return `${this.getTextRunOutOfTime()}<br>${this.getYourTeamWonPointsTotal()}.`
        }
        // I14
        if (!this.result.timeout && slide.multipleChoice &&
          !this.isCorrectGetPoint && partiallyCorrect &&
          dataCorrectAnswers.audienceMissCorrectAnswers !== 0) {
          return `${this.getTextYouMissedCorrectAnswers(dataCorrectAnswers)}<br>${this.getTextYouScoredPointsForYourTeam()}<br>${this.getYourTeamWonPointsTotal()}.`
        }
        // I15
        if (!this.result.timeout && slide.multipleChoice &&
          this.isCorrectGetPoint && partiallyCorrect &&
          dataCorrectAnswers.audienceMissCorrectAnswers !== 0) {
          return `${this.getTextYouPickedCorrectAnswers(dataCorrectAnswers)}<br>${this.getTextYouScoredPointsForYourTeam()}<br>${this.getYourTeamWonPointsTotal()}.`
        }
        // F14
        if (!this.result.timeout && slide.multipleChoice &&
          !this.isCorrectGetPoint && this.result.correct) {
          return `${this.getTextYouScoredPoints()}<br>${this.getYourTeamWonPointsTotal()}!`
        }
        // F15
        if (!this.result.timeout && slide.multipleChoice &&
          this.isCorrectGetPoint && this.result.correct) {
          return `${this.getTextYouScoredPoints()}<br>${this.getYourTeamWonPointsTotal()}!`
        }
        // F16
        if (!this.result.timeout && !slide.multipleChoice &&
          this.result.correct) {
          return `${this.getTextYouScoredPoints()}<br>${this.getYourTeamWonPointsTotal()}!`
        }
        // G14
        if (!this.result.timeout && slide.multipleChoice &&
          !this.isCorrectGetPoint && !this.result.correct) {
          return `${this.getTextYouScoredPointsForYourTeam()}<br>${this.getYourTeamWonPointsTotal()}.`
        }
        // G15
        if (!this.result.timeout && slide.multipleChoice &&
          this.isCorrectGetPoint && !this.result.correct) {
          return `${this.getTextYouScoredPointsForYourTeam()}<br>${this.getYourTeamWonPointsTotal()}.`
        }
        // G16
        if (!this.result.timeout && !slide.multipleChoice &&
          !this.result.correct) {
          return `${this.getTextYouScoredPointsForYourTeam()}<br>${this.getYourTeamWonPointsTotal()}.`
        }
      }
      return text
    },
    getTextRunOutOfTime() {
      return this.$t('runOutOfTime')
    },
    getTextNoOneTeamAnswerInTime() {
      return this.$t('noOneAnsweredInTime')
    },
    getTextFastestYouHaveWonPointsForTeam() {
      if (this.result.fastest.totalPoint === 1) {
        return this.$t('youHaveWonPointForTeam', {
          msg: `<strong>${this.result.fastest.totalPoint}</strong>`,
        })
      }
      return this.$t('youHaveWonPointsForTeam', {
        msg: `<strong>${Util.formatNumber(this.result.fastest.totalPoint)}</strong>`,
      })
    },
    getTextYouMissedCorrectAnswers(data) {
      if (data.audienceMissCorrectAnswers === 1) {
        return this.$t('youMissedCorrectAnswer', {
          msg: data.audienceMissCorrectAnswers,
        })
      }
      return this.$t('youMissedCorrectAnswers', {
        msg: data.audienceMissCorrectAnswers,
      })
    },
    getTextYouPickedCorrectAnswers(data) {
      return this.$t('youPickedCorrectAnswers', {
        msg: data.audienceCorrectAnswers.length,
        num: data.totalCorrectAnswers,
      })
    },
    filterProfaneWords(word) {
      return Util.filterProfaneWords(word)
    },
    getTextTimesUp() {
      let text = ''
      if (this.result.timeout) {
        text = this.$t('timesUp')
      }
      return text
    },
    getTextTheCorrectAnswerIs() {
      let text = ''
      if (this.result.timeout && this.typeAnswer && this.$store.state.slide.slideType === 'typeAnswer') {
        text = this.$t('theCorrectAnswerIs', {
          msg: `<strong>${this.typeAnswer}</strong>`,
        })
      }
      return text
    },
    getTextFastestTeamMateAlreadyAnswer() {
      const hasAudienceInfo = this.result.fastest.audienceEmoji && this.result.fastest.audienceName
      return this.$t('hasAlreadyAnswered', {
        msg: hasAudienceInfo ?
          `<strong>${this.result.fastest.audienceEmoji}${this.filterProfaneWords(this.result.fastest.audienceName)}</strong>` : '',
      })
    },
    getTextYouWereTheFastest() {
      return this.$t('youWereFastestInTeam')
    },
    getTextYouHaveRunOutOfTime() {
      const { teamScoringRule } = this.$store.state.presentation.teamScoringRule
      const { timeout } = this.result

      let text = ''
      if (timeout && teamScoringRule === 'fastest') {
        if (this.isFastestAudience) {
          text = this.$t('noOneAnsweredInTime')
        }
        text = this.$t('runOutOfTime')
      }
      if (timeout && (teamScoringRule === 'average' || teamScoringRule === 'total')) {
        text = this.$t('runOutOfTime')
      }
      return text
    },
    getTextYourAnswerNotCount() {
      return this.$t('yourAnswerNotCount')
    },
    getFastestYourTeamHasScoredPoints() {
      let text = ''
      if (this.result.fastest.totalPoint === 1) {
        text = this.$t('yourTeamWonPoint', {
          msg: `<strong>${this.result.fastest.totalPoint}</strong>`,
        })
      }
      text = this.$t('yourTeamWonPoints', {
        msg: `<strong>${Util.formatNumber(this.result.fastest.totalPoint)}</strong>`,
      })
      return text
    },
    getYourTeamHasScoredPoints() {
      let text = ''
      if (this.result.point === 1) {
        text = this.$t('yourTeamWonPoint', {
          msg: `<strong>${this.result.point}</strong>`,
        })
      }
      text = this.$t('yourTeamWonPoints', {
        msg: `<strong>${Util.formatNumber(this.result.point)}</strong>`,
      })
      return text
    },
    getYourTeamWonPointsTotal() {
      let text = ''
      if (this.result.fastest.totalPoint === 1) {
        text = this.$t('yourTeamWonPointTotal', {
          msg: `<strong>${this.result.fastest.totalPoint}</strong>`,
        })
      }
      text = this.$t('yourTeamWonPointsTotal', {
        msg: `<strong>${Util.formatNumber(this.result.fastest.totalPoint)}</strong>`,
      })
      return text
    },
    getTextYouScoredPointsForYourTeam() {
      if (this.result.point === 1) {
        return this.$t('youScoredPointForYourTeam', {
          msg: `<strong>${this.result.point}</strong>`,
        })
      }
      return this.$t('youScoredPointsForYourTeam', {
        msg: `<strong>${Util.formatNumber(this.result.point)}</strong>`,
      })
    },
    getTextYouScoredPoints() {
      if (this.result.point === 1) {
        return this.$t('youScoredPoint', {
          msg: `<strong>${this.result.point}</strong>`,
        })
      }
      return this.$t('youScoredPoints', {
        msg: `<strong>${Util.formatNumber(this.result.point)}</strong>`,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.result {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 16px;
  text-transform: uppercase;
}
@-webkit-keyframes leaves {
  0% {
    -webkit-transform: scale(1);
  }
  100% {
    -webkit-transform: scale(1.2);
  }
}
@keyframes leaves {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.team-result__text {
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 8px;
}
.type-answer-result {
  margin-bottom: 8px;
}
</style>
